class InputNotification {
  /**
   * Create new input notification
   * @param {HTMLInputElement} input Form input
   */
  constructor (input) {
    this.input = input

    /** @type {HTMLDivElement} */
    this.notification = document.querySelector(`#${input.dataset.notification}`)

    this.hide = this.hide.bind(this)
  }

  init () {
    this.input.addEventListener('input', this.hide)
  }

  hide () {
    this.input.removeEventListener('input', this.hide)

    if (this.notification) {
      this.notification.hidden = true
    }
  }
}

const inputs = document.querySelectorAll('.js-input-notification')
inputs.forEach(input => new InputNotification(input).init())
